<template>
    <div class="about-container" id="about">
        <div class="container">
            <div class="page-title mb-3">
                <h2>Sobre Power Stones</h2>
            </div>
            <p class="text-center">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt accusamus quo porro nisi perspiciatis, ipsum optio quia odio modi? Sunt ipsum asperiores fugit tempore fugiat voluptatum quis vel eius similique.</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "aboutComponent"
}
</script>
<style scoped>
</style>